module.exports = __webpack_public_path__ + "static/media/roundaboutCCW225.a9b35769.svg";